import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { PlugOutline } from '@lyearn/icons';
import { Stack, Typography } from '@lyearn/ui';

function EmptyState({ searchText }: { searchText: string }) {
  const { t } = useTranslation();

  // todo refactor
  if (searchText.length) {
    return (
      <Stack alignItems="center" className="flex-1" direction="col" justifyContent="center">
        <Typography className="w-192 text-center" color="text-text-placeholder" variant="label-01">
          {t('Admin:GlobalContent.NoResultsFound', {
            searchString: searchText,
          })}
        </Typography>
      </Stack>
    );
  }

  return (
    <Stack alignItems="center" className="flex-1" direction="col" justifyContent="center">
      <PlugOutline className="mb-16 h-32 w-32" fillColorToken="icon-placeholder" />
      <Typography className="w-192 text-center" color="text-text-placeholder" variant="label-01">
        {t('LyearnConnect:EmptyState')}
      </Typography>
    </Stack>
  );
}

export default EmptyState;
